module.exports = {
	"activeUser": {
		"first_name": "",
		"last_name": "",
		"user_type": "",
		"phone": ""
	},
	"credit": {},
	"display": {
		"isLoading": false,
		"navbar": {
			"showNavbar": true,
			"showFooter": true
		},
		"showAddPropertyModal": false,
		"showAddListingModal": false,
		"showInviteTenantModal": false,
		"appDisplay": {
			"applicationKey": 0,
			"showAddHistory": false
		},
		"flowKeys": [],
		"modals": [],
		"overlays": []
	},
	"tenant": {
		"application": {},
		"billing": {
			"status": {},
			"payment_method": {},
			"history": [],
			"stripe_details": {}
		},
		"interest_list": [],
		"invitations": [],
		"roommate_group": {
			"coordinator": {},
			"roommates": [],
			"pending_invitations": [],
			"applied_listings": []
		},
		"credit": {},
		"idmaStatus": "",
		"listing_preferences": {},
		"recommended_listings": []
	},
	"guarantor": {
		"first_name": "",
		"last_name": "",
		"email": "",
		"phone": "",
		"address_place_id": "",
		"address_details": {},
		"relation": "",
		"confirmed": false,
		"tenant": {},
		"verification_status": ""
	},
	"reference": {
		"name": "",
		"email": "",
		"phone": "",
		"confirmed": false,
		"sentiment": [],
		"rental": {
			"tenant": {}
		},
		"secondary_sources": [],
		"created": "",
		"modified": "",
		"was_tenant": true,
		"on_time_rent": true,
		"insufficient_funds": false,
		"eviction": false,
		"criminal_activity": false,
		"smoking": false,
		"has_pets": false,
		"property_condition_acceptable": true,
		"security_deposit_returned": true,
		"would_rent_to_again": true,
		"comments": ""
	},
	"owner": {
		"address_line_1": "",
		"address_line_2": "",
		"acceptance_message": "",
		"applications": [],
		"business_details": {},
		"city": "",
		"email_verified": true,
		"involvement": {
			"leases": true,
			"listings": true
		},
		"is_transunion_data_set": false,
		"properties": [],
		"rejection_message": "",
		"state": "",
		"stripe_data": {},
		"zip_code": ""
	},
	"listings": {},
	"unclaimed_properties": []
};


//////////////////
// WEBPACK FOOTER
// ./src/initialState.json
// module id = 207
// module chunks = 0